import { render, staticRenderFns } from "./ApiGroup.vue?vue&type=template&id=4b762451&scoped=true"
import script from "./ApiGroup.vue?vue&type=script&lang=js"
export * from "./ApiGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b762451",
  null
  
)

export default component.exports